/* eslint-disable react/jsx-props-no-spreading */
import { PropTypes as MicromagPropTypes } from '@micromag/core';
import PropTypes from 'prop-types';
import React, { useCallback, useState, useMemo } from 'react';
// import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import useStoryPublications from '../../hooks/useStoryPublications';
import useStorySocket from '../../hooks/useStorySocket';

import StoryPublications from '../lists/StoryPublications';

const propTypes = {
    story: MicromagPropTypes.story.isRequired,
    count: PropTypes.number,
    className: PropTypes.string,
};

const defaultProps = {
    count: 10,
    className: null,
};

const RecentPublications = ({ story, count, className }) => {
    const { publications } = useStoryPublications(story.id, null, null, count);
    const [socketPublications, setSocketPublications] = useState([]);

    const onSocketMessage = useCallback(
        ({ event = null, data }) => {
            if (
                event === 'publications.created' ||
                event === 'publications.published' ||
                event === 'publications.failed'
            ) {
                const { id: dataId = null } = data || {};
                setSocketPublications([
                    ...socketPublications.filter(({ id = null }) => id !== null && id !== dataId),
                    data,
                ]);
            }
        },
        [socketPublications, setSocketPublications],
    );
    useStorySocket(story, onSocketMessage);

    const finalPublications = useMemo(
        () =>
            [...socketPublications, ...(publications || [])]
                .reduce((arr, it) => {
                    if (!arr.find((item) => item.id === it.id)) {
                        arr.push(it);
                    }
                    return arr;
                }, [])
                .reduce((arr, it) => {
                    if (
                        !it.failed ||
                        !arr.find((item) => item.failed && item.service === it.service)
                    ) {
                        arr.push(it);
                    }
                    return arr;
                }, [])
                .sort(({ updated_at: aDate }, { updated_at: bDate }) => bDate.localeCompare(aDate)),
        [socketPublications, publications],
    );

    return finalPublications !== null && finalPublications.length > 0 ? (
        <section className={className}>
            <h4>
                <FormattedMessage defaultMessage="Recent publications" description="Card title" />
            </h4>
            <StoryPublications items={finalPublications} story={story} />
        </section>
    ) : null;
};

RecentPublications.propTypes = propTypes;
RecentPublications.defaultProps = defaultProps;

export default RecentPublications;
